import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["placeholder", "inputWrapperClassName", "inputFieldClassName"],
  _excluded2 = ["label", "input", "placeholder"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { RootCloseWrapper } from 'react-overlays';
import _noop from 'lodash/noop';
import _debounce from 'lodash/debounce';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import ActionButton from '../../molecules/ActionButton';
import TextInput from '../../atoms/Input';
import Select from '../../molecules/Select';
import { SIZES } from '../../atoms/FontIcon/Icon.constants';
import PropertyControlledComponent from '../../molecules/PropertyControlledComponent';
import ExpandableSearchUtils from './ExpandableSearchField.utils';
import styles from './expandableSearchField.module.scss';
var ENTER_KEY_CODE = 13;
var ExpandableSearchField = /*#__PURE__*/function (_React$Component) {
  _inherits(ExpandableSearchField, _React$Component);
  var _super = _createSuper(ExpandableSearchField);
  function ExpandableSearchField(props) {
    var _this;
    _classCallCheck(this, ExpandableSearchField);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      isActive: false
    });
    _defineProperty(_assertThisInitialized(_this), "setInputFocus", function () {
      return _this._input.current.input.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "setInputBlur", function () {
      return _this._input.current.input.blur();
    });
    _defineProperty(_assertThisInitialized(_this), "resetInputValue", function () {
      var value = _this.props.value;
      _this.setState({
        inputValue: value,
        lastSearchValue: EMPTY_STRING
      });
    });
    _defineProperty(_assertThisInitialized(_this), "updateInputText", function (value) {
      var onChange = _this.props.onChange;
      onChange(value);
    });
    _defineProperty(_assertThisInitialized(_this), "updateInputValue", function () {
      var value = _this.props.value;
      _this.setState({
        inputValue: value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
      var value = event.target.value;
      var onSearch = _this.props.onSearch;
      if (event.keyCode === ENTER_KEY_CODE && value) {
        _this.lastSearchValue = value;
        onSearch(value);
        _this.setInputBlur();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var onSearch = _this.props.onSearch;
      var searchValue = e.target.value;
      if (searchValue === EMPTY_STRING && _this.lastSearchValue !== EMPTY_STRING) {
        onSearch(searchValue);
      }
      _this.updateValue(searchValue);
      _this.setState({
        inputValue: searchValue
      });
    });
    _defineProperty(_assertThisInitialized(_this), "activate", function () {
      _this.setState({
        isActive: true
      }, _this.setInputFocus());
    });
    _defineProperty(_assertThisInitialized(_this), "deactivate", function () {
      var inputValue = _this.state.inputValue;
      var searchField = _this.props.searchField;
      if (!inputValue && !searchField) {
        _this.setState({
          isActive: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setClearValues", function () {
      var _this$props = _this.props,
        onChange = _this$props.onChange,
        onSearch = _this$props.onSearch;
      onChange(EMPTY_STRING);
      if (_this.lastSearchValue !== EMPTY_STRING) {
        onSearch(EMPTY_STRING);
      }
      _this.lastSearchValue = EMPTY_STRING;
    });
    _defineProperty(_assertThisInitialized(_this), "clearValue", function () {
      var inputValue = _this.state.inputValue;
      var hasValue = !!inputValue;
      if (hasValue) {
        _this.setInputFocus();
      } else {
        _this.setInputBlur();
      }
      _this.setState({
        isActive: hasValue,
        inputValue: EMPTY_STRING
      }, _this.setClearValues());
    });
    _defineProperty(_assertThisInitialized(_this), "renderSearchableFieldSelect", function () {
      var _this$props2 = _this.props,
        searchableFieldsOptions = _this$props2.searchableFieldsOptions,
        onChangeSearchField = _this$props2.onChangeSearchField,
        searchField = _this$props2.searchField;
      return /*#__PURE__*/React.createElement(Select, {
        className: styles.expandableInputFiledSelect,
        dropdownMatchSelectWidth: false,
        options: searchableFieldsOptions,
        onChange: onChangeSearchField,
        value: searchField,
        defaultValue: searchField
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderSearchIcon", function () {
      var isActive = _this.state.isActive;
      return /*#__PURE__*/React.createElement(ActionButton, {
        icon: "icon-search",
        color: "black",
        onClick: _this.activate,
        disabled: isActive
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderCloseIcon", function () {
      return /*#__PURE__*/React.createElement(ActionButton, {
        icon: "icon-close",
        color: "black",
        size: SIZES.S,
        className: "".concat(styles.expandableInputCloseIcon, " mx-1"),
        onClick: _this.clearValue
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderSearchTextBox", function () {
      var _this$props3 = _this.props,
        placeholder = _this$props3.placeholder,
        inputWrapperClassName = _this$props3.inputWrapperClassName,
        inputFieldClassName = _this$props3.inputFieldClassName,
        rest = _objectWithoutProperties(_this$props3, _excluded);
      var _this$state = _this.state,
        isActive = _this$state.isActive,
        inputValue = _this$state.inputValue;
      return /*#__PURE__*/React.createElement(TextInput, _extends({}, rest, {
        placeholder: placeholder,
        className: cx(styles.expandableInput, _defineProperty({}, styles.expandableInputActive, isActive), {
          'is-paddingless': !isActive
        }),
        inputWrapperClass: cx(styles.expandableInputSearchInput, inputFieldClassName, _defineProperty({}, styles.expandableInputHideSearchInput, !isActive)),
        innerRef: _this._input,
        onChange: _this.handleChange,
        onKeyUp: _this.onKeyUp,
        value: inputValue,
        inputContainerClass: cx(styles.inputContainerClass, _defineProperty({}, inputWrapperClassName, isActive))
      }));
    });
    var searchInputRef = _this.props.searchInputRef;
    _this._input = searchInputRef || /*#__PURE__*/React.createRef();
    _this.updateValue = _debounce(_this.updateInputText, 400);
    return _this;
  }
  _createClass(ExpandableSearchField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
        value = _this$props4.value,
        isActive = _this$props4.isActive;
      this.setState({
        isActive: isActive
      });
      if (value) {
        this.setState({
          isActive: true,
          inputValue: value
        }, this.setInputFocus());
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = prevProps.value;
      var newValue = this.props.value;
      if (newValue === value) return;
      if (newValue === EMPTY_STRING && newValue !== value) {
        this.resetInputValue();
        return;
      }
      this.updateInputValue();
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var isSearchIconViewable = ExpandableSearchUtils.isSearchIconViewable(this);
      var isClearIconViewable = ExpandableSearchUtils.isClearIconViewable(this);
      return /*#__PURE__*/React.createElement(RootCloseWrapper, {
        noWrap: true,
        onRootClose: this.deactivate
      }, /*#__PURE__*/React.createElement("div", {
        className: cx(className, styles.expandableInputContainer, 'relative')
      }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: isSearchIconViewable
      }, this.renderSearchIcon()), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: isClearIconViewable
      }, this.renderSearchableFieldSelect()), this.renderSearchTextBox(), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: isClearIconViewable
      }, this.renderCloseIcon())));
    }
  }]);
  return ExpandableSearchField;
}(React.Component);
_defineProperty(ExpandableSearchField, "propTypes", {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  isClearable: PropTypes.bool,
  // eslint-disable-line react/no-unused-prop-types
  className: PropTypes.string,
  placeholder: PropTypes.string,
  searchContainerActive: PropTypes.string,
  isActive: PropTypes.bool,
  searchableFieldsOptions: PropTypes.array,
  onChangeSearchField: PropTypes.func,
  searchField: PropTypes.string,
  searchInputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })])
});
_defineProperty(ExpandableSearchField, "defaultProps", {
  onSearch: _noop,
  onChange: _noop,
  className: EMPTY_STRING,
  placeholder: __('Search...'),
  searchContainerActive: EMPTY_STRING,
  isClearable: true,
  value: EMPTY_STRING,
  isActive: false,
  searchableFieldsOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })),
  onChangeSearchField: _noop,
  searchField: '',
  searchInputRef: null
});
var renderField = function renderField(_ref) {
  var label = _ref.label,
    input = _ref.input,
    placeholder = _ref.placeholder,
    rest = _objectWithoutProperties(_ref, _excluded2);
  var value = input.value,
    onChange = input.onChange;
  return /*#__PURE__*/React.createElement(ExpandableSearchField, _extends({
    value: value,
    onChange: onChange,
    placeholder: placeholder
  }, rest));
};
ExpandableSearchField.renderField = renderField;
export default ExpandableSearchField;